import { Chip } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';

import { AlertSubtype } from 'common/src/types/enums/AlertSubtype.enum';
import { AlertType } from 'common/src/types/enums/AlertType.enum';
import type { IAlert } from 'common/src/types/interfaces';

import { multipleFilterOperators } from 'portal/src/components/common/Filters/CustomCollectors';
import addDateColumnProps from 'portal/src/components/common/tables/addDateColumnProps';
import addTriStateColumnProps from 'portal/src/components/common/tables/addTriStateColumnProps';
import { timestampColumnWidth } from 'portal/src/components/common/tables/columnStyling';

import { getAlertTypeColor } from './utils/alertTypeColors';
import {
  ALERT_RESOLUTION_STATUS_OPTIONS,
  getAlertResolutionFilters,
  getAlertResolutionStatus,
} from './utils/alertsFiltering';

const getAlertTableColumns = (
  subtypeFilterOptions: { value: AlertSubtype; label: AlertSubtype }[],
): GridColDef[] => [
  {
    field: 'createdAt',
    filterable: false,
    sortable: false,
    ...addDateColumnProps('Created', timestampColumnWidth, 'Ppp', 'left'),
  },
  {
    field: 'type',
    headerName: 'Type',
    filterable: false,
    sortable: false,
    width: 140,
    renderCell: (params) => (
      <Chip
        label={params.value}
        sx={{
          backgroundColor: getAlertTypeColor(params.value as AlertType),
          color: 'white',
        }}
        variant="filled"
      />
    ),
  },
  {
    field: 'subtype',
    headerName: 'Subtype',
    sortable: false,
    flex: 1,
    minWidth: 200,
    filterOperators: multipleFilterOperators({
      service: {
        fieldset: { key: 'value', label: 'label', value: 'value' },
        data: subtypeFilterOptions,
      },
    }),
  },
  {
    field: 'resolved',
    headerName: 'Resolved',
    sortable: false,
    ...addTriStateColumnProps<
      IAlert,
      (typeof ALERT_RESOLUTION_STATUS_OPTIONS)[number]
    >({
      getLabel: (row) => getAlertResolutionStatus(row.subtype, row.resolved),
      valueOptions: ALERT_RESOLUTION_STATUS_OPTIONS,
      colors: [undefined, 'error', 'success'],
      filterMode: 'server',
      serverAdditionalFilters: getAlertResolutionFilters,
      replaceBaseFilter: () => true,
    }),
  },
];

export default getAlertTableColumns;
